<template>
  <div style="height: 100%">
    <div class="img">
      <!-- <img src="../assets/images/login_background.svg" alt="" /> -->
    </div>
    <div class="opacity_wrapper"></div>
    <div class="form_container">
      <div class="head_text_wrap">
        <div class="head_text">고객 접수용</div>
      </div>
      <div class="section1">
        <img calss="img_logo" src="../assets//images/login_logo.svg" alt="" />
        <div class="section1_text">조이웍스 A/S 온라인 신청서</div>
      </div>
      <div class="section2">
        <div class="input_wrap">
          <input placeholder="전화번호를 입력해 주세요." class="input_text" :class="{ input_text2: !chk }" type="text" v-model="param.login_id" @keyup.enter="sendSMS" />
          <div v-if="chk" class="input_button" @click="sendSMS">인증</div>
          <div v-if="!chk" class="input_button" @click="sendSMS">재전송</div>
        </div>
        <div class="input_wrap">
          <input placeholder="인증번호를 입력 해주세요." :class="{ input_text: !chk, input_text2: chk }" type="text" ref="focus" v-model="param.password" @keyup.enter="login" :readonly="chk" />
          <div class="timeStamp">{{ time.mm }}:{{ time.ss }}</div>
        </div>
        <div v-if="timeover" class="input_wrap">
          <div class="time_text">인증번호 시간이 초과 되었습니다.</div>
        </div>
      </div>
      <div class="section3">
        <div @click="login" class="login_button">로그인</div>
      </div>
      <div class="section4">
        <img src="../assets/images/login_under.svg" alt="" />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import router from "@/router";
import { useStore } from "vuex";
import authAPI from "@/api/authAPI";
import { ref } from "vue";
import { phoneNumberChk } from "@/common/common";
const store = useStore();
const focus: any = ref(null);
const param = ref({
  login_id: "",
  password: "",
});
const time: any = ref({
  mm: 3,
  ss: "00",
  chktime: 180,
});
const chk = ref(true);
let timeover = false;

let interval: any = null;
const reset = () => {
  clearInterval(interval);
  timeover = false;
  param.value.password = "";
  time.value = {
    mm: 3,
    ss: "00",
    chktime: 180,
  };
};
const takeTarget = () => {
  focus.value.focus();
  interval = setInterval(function () {
    if (time.value.chktime > 0) {
      // >= 0 으로하면 -1까지 출력된다.
      time.value.chktime = time.value.chktime - 1; // 여기서 빼줘야 3분에서 3분 또 출력되지 않고, 바로 2분 59초로 넘어간다.
      let min = Math.floor(time.value.chktime / 60);
      let sec = String(time.value.chktime % 60).padStart(2, "0");
      time.value.mm = min;
      time.value.ss = sec;
      if (time.value.mm == 0 && time.value.ss == 0) {
        timeover = true;
      }
      // time = time - 1
    } else {
      timeover = true;
    }
  }, 1000);
};
const sendSMS = () => {
  reset();
  if (phoneNumberChk(param.value.login_id)) {
    authAPI.smsAuth(param.value).then(() => {
      chk.value = false;
      takeTarget();
    });
  } else {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "휴대폰번호를 확인하세요.",
    });
    return;
  }
};
const login = () => {
  if (!timeover) {
    authAPI.login(param.value).then((res: any) => {
      if (res.data.status != 200) {
        window.customAlert({
          title: "A/S 고객접수",
          msg: "인증번호를 확인하세요.",
        });
        return;
      }
      store.commit("setUserInfo", res.data.data);
      router.push({
        name: "clientHome",
      });
    });
  } else {
    window.customAlert({
      title: "A/S 고객접수",
      msg: "인증번호 시간이 초과 되었습니다. <br>재전송 해주세요.",
      sCb: function () {
        param.value.password = "";
      },
    });
    return;
  }
};
</script>
<style scoped>
.opacity_wrapper {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
}
.form_container {
  background: #f9f9f9;
  position: fixed;
  top: calc(0%);
  right: calc(10%);
  width: 382px;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  opacity: 0.9;
}
.img {
  height: 940px;
}
.img > img {
  width: 100%;
  height: 100%;
}
.section1 {
  display: flex;
  flex-direction: column;
  gap: 11px;
  padding: 114px 54px 71px 54px;
}
.section1_text {
  font-size: 24px;
  font-family: "Noto Sans CJK KR-Bold";
  line-height: 36px;
  color: #000000;
  letter-spacing: -1.9px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.text_highLight {
  font-family: "Noto Sans CJK KR-Bold";
  letter-spacing: -0.5px;
}
.section2 {
  display: flex;
  flex-direction: column;
  padding: 0px 30px 12px 30px;
  gap: 12px;
}
.input_wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  position: relative;
}
.input_text::placeholder {
  font-family: "Noto Sans CJK KR-Medium";
  color: #383838;
}
.input_text {
  border: 2px solid #383838;
  border-radius: 6px;
  width: 100%;
  height: 50px;
  padding: 14px;
  font-size: 14px;
  line-height: 22px;
  font-family: "Noto Sans CJK KR-Regular";
  color: #000000;
}
.input_button {
  border: 1px solid #000000;
  background-color: #000000;
  border-radius: 6px;
  color: #ffffff;
  width: 108px;
  height: 50px;
  font-size: 15px;
  line-height: 22px;
  font-family: "Noto Sans CJK KR-Bold";
  cursor: pointer;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.input_text2 {
  border: 2px solid #e9e9e9;
  background-color: #ededed;
  border-radius: 6px;
  width: 100%;
  height: 50px;
  padding: 14px;
  font-size: 14px;
  line-height: 22px;
  font-family: "Noto Sans CJK KR-Regular";
  color: #000000;
}
.input_text2::placeholder {
  color: #c7c7c7;
  font-family: "Noto Sans CJK KR-Light";
  line-height: 22px;
}
.timeStamp {
  font-family: "Noto Sans CJK KR-Medium";
  color: #006da0;
  position: absolute;
  right: 12px;
}
.head_text_wrap {
  padding-top: 10px;
  padding-right: 30px;
}
.head_text {
  letter-spacing: -1px;
  font-family: "Noto Sans CJK KR-Medium";
  color: #006da0;
  text-align: right;
}
.section3 {
  display: flex;
  justify-content: center;
  padding: 0px 30px;
}
.section3_img {
  cursor: pointer;
}
.time_text {
  letter-spacing: -0.2px;
  font-size: 14px;
  color: red;
}
.section4 {
  display: flex;
  justify-content: center;
  margin-top: auto;
  margin-bottom: 48px;
}
.login_button {
  width: 100%;
  background-color: #000000;
  color: #ffffff;
  font-family: "Noto Sans CJK KR-Medium";
  font-size: 18px;
  letter-spacing: -0.5px;
  line-height: 37px;
  border-radius: 6px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
